// Re-export the new GDPR-compliant CookieConsentBanner component
export { default } from './CookieConsentBanner';
